var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "128", height: "128", viewBox: "0 0 128 128", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M64 0C28.711 0 0 28.709 0 64s28.711 64 64 64 64-28.709 64-64S99.289 0 64 0zm0 123.077C31.427 123.077 4.923 96.573 4.923 64 4.923 31.427 31.427 4.923 64 4.923c32.573 0 59.077 26.504 59.077 59.077 0 32.573-26.504 59.077-59.077 59.077z" }),
    React.createElement("path", { d: "M94.159 37.75L56.327 80.31 33.536 62.077a2.463 2.463 0 0 0-3.459.385 2.463 2.463 0 0 0 .384 3.46l24.616 19.693c.453.362.997.539 1.538.539.68 0 1.357-.28 1.842-.827L97.84 41.019a2.459 2.459 0 0 0-.204-3.473 2.46 2.46 0 0 0-3.478.204z" })
  );
});